var _path, _path2, _line, _path3, _path4, _line2, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Apk50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffab91",
    d: "M32.865,9H16.088C14.382,9,13,10.382,13,12.088v31.824C13,45.618,14.382,47,16.088,47h23.824 C41.618,47,43,45.618,43,43.912V19.076c0-0.533-0.213-1.044-0.591-1.419l-8.135-8.076C33.9,9.209,33.393,9,32.865,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M38.5,14.5h-7c-1.105,0-2-0.895-2-2v-7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 38.5,
    y1: 22.5,
    y2: 14.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M9.5,35.979V39.5c0,1.657,1.343,3,3,3h23c1.657,0,3-1.343,3-3v-3.436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M22.234,5.5H12.5c-1.657,0-3,1.343-3,3v3.819v5.362v3.915"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M25.851,35.5H8.5c-0.552,0-1-0.448-1-1v-11c0-0.552,0.448-1,1-1h5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M20.872,22.5H39.5c0.552,0,1,0.448,1,1v11c0,0.552-0.448,1-1,1h-7.777"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M24.5,25h-2c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1s1-0.448,1-1v-1h1c1.654,0,3-1.346,3-3 S26.154,25,24.5,25z M24.5,29h-1v-2h1c0.551,0,1,0.449,1,1S25.051,29,24.5,29z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M17.923,25.615C17.767,25.242,17.404,25,17,25s-0.768,0.243-0.923,0.615l-2.5,6 c-0.212,0.51,0.028,1.095,0.538,1.308c0.51,0.212,1.096-0.029,1.308-0.538L15.583,32h2.834l0.16,0.385 C18.737,32.768,19.109,33,19.5,33c0.128,0,0.258-0.025,0.384-0.078c0.51-0.212,0.75-0.798,0.538-1.308L17.923,25.615z M16.417,30 L17,28.6l0.583,1.4H16.417z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M32.302,29l1.966-2.36c0.354-0.424,0.296-1.055-0.128-1.408c-0.424-0.354-1.055-0.295-1.408,0.128 L30.5,28.038V26c0-0.552-0.448-1-1-1s-1,0.448-1,1v6c0,0.552,0.448,1,1,1s1-0.448,1-1v-2.038l2.232,2.678 C32.93,32.877,33.214,33,33.5,33c0.226,0,0.453-0.076,0.64-0.232c0.424-0.354,0.481-0.984,0.128-1.408L32.302,29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Apk50);
export default __webpack_public_path__ + "static/media/icons8-apk-50.6ed6d8feff4cedbe8114a56ed26f9d1d.svg";
export { ForwardRef as ReactComponent };